import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor } from '@zillow/constellation';
import HtmlToReact, { Parser } from 'html-to-react';
import { BlockQuote } from '@zillow/zrs-cms';
import { withTrigger } from '../../util/helpers.js';

var Quote = function Quote(_ref) {
  var attrs = _ref.attrs;
  var content = attrs.content,
    citation = attrs.citation;
  var htmlToReactParser = new Parser();
  var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
  var processingInstructions = [{
    shouldProcessNode: function shouldProcessNode(node) {
      return node.name === 'a';
    },
    processNode: function processNode(node, children, nodeIndex) {
      var AnchorWithTrigger = withTrigger(function () {
        return /*#__PURE__*/React.createElement(Anchor, _extends({
          key: nodeIndex
        }, node.attribs), children);
      });
      return /*#__PURE__*/React.createElement(AnchorWithTrigger, {
        triggerLink: node.attribs.href
      }, children);
    }
  }, {
    // Anything else
    shouldProcessNode: function shouldProcessNode() {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }];
  var parsedContent = htmlToReactParser.parseWithInstructions(content, function () {
    return true;
  }, processingInstructions);
  return /*#__PURE__*/React.createElement(BlockQuote, null, /*#__PURE__*/React.createElement(BlockQuote.Content, null, parsedContent), citation && /*#__PURE__*/React.createElement(BlockQuote.Citation, null, citation));
};
Quote.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    content: PropTypes.string,
    citation: PropTypes.string
  }).isRequired
} : {};
var Quote$1 = Quote;

export { Quote$1 as default };
